import script from "./FamilyGroupMemberManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./FamilyGroupMemberManage.vue?vue&type=script&lang=ts&setup=true"

import "./FamilyGroupMemberManage.vue?vue&type=style&index=0&id=8b2dd406&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b2dd406"]])

export default __exports__